// GENERATED FILE — do not edit by hand.
// Written by `scripts/i18n/regenerate-barrels.mjs`, verified by
// `scripts/check-i18n.mjs`. Add a namespace by adding its JSON file; this
// barrel follows automatically.

import accountSetup from "./accountSetup.json";
import accountSetupEmail from "./accountSetupEmail.json";
import accountSetupEpost from "./accountSetupEpost.json";
import accountSetupKi from "./accountSetupKi.json";
import accountSetupList from "./accountSetupList.json";
import accountSetupPhone from "./accountSetupPhone.json";
import accountSetupWhatsapp from "./accountSetupWhatsapp.json";
import agentChats from "./agentChats.json";
import agentChatsImpl from "./agentChatsImpl.json";
import agentExecutions from "./agentExecutions.json";
import agentOnboardingTour from "./agentOnboardingTour.json";
import agentOptimization from "./agentOptimization.json";
import agentOptimizationAgent from "./agentOptimizationAgent.json";
import agentOptimizationChat from "./agentOptimizationChat.json";
import agentOptimizationList from "./agentOptimizationList.json";
import agentOptimizationMarks from "./agentOptimizationMarks.json";
import agentOptimizationProblem from "./agentOptimizationProblem.json";
import agentRunChat from "./agentRunChat.json";
import apiDocumentation from "./apiDocumentation.json";
import assemblies from "./assemblies.json";
import automations from "./automations.json";
import boardAutomations from "./boardAutomations.json";
import buildingScope from "./buildingScope.json";
import bulkActions from "./bulkActions.json";
import calendar from "./calendar.json";
import clips from "./clips.json";
import common from "./common.json";
import communityComposer from "./communityComposer.json";
import communityFrame from "./communityFrame.json";
import communityLive from "./communityLive.json";
import communityPosts from "./communityPosts.json";
import communityTemplates from "./communityTemplates.json";
import connectAi from "./connectAi.json";
import dataSources from "./dataSources.json";
import demoPost from "./demoPost.json";
import docs from "./docs.json";
import documents from "./documents.json";
import documentsAdminTour from "./documentsAdminTour.json";
import documentsOnboardingTour from "./documentsOnboardingTour.json";
import drive from "./drive.json";
import einvoiceRuleHelp from "./einvoiceRuleHelp.json";
import einvoiceRules from "./einvoiceRules.json";
import emailAccountDisconnected from "./emailAccountDisconnected.json";
import emailImportOnboardingTour from "./emailImportOnboardingTour.json";
import errors from "./errors.json";
import exports from "./exports.json";
import featurePages from "./featurePages.json";
import financeAiSelfPosting from "./financeAiSelfPosting.json";
import financeAllocation from "./financeAllocation.json";
import financeApprovals from "./financeApprovals.json";
import financeAudit from "./financeAudit.json";
import financeAuditAccess from "./financeAuditAccess.json";
import financeAuditLink from "./financeAuditLink.json";
import financeAutopilot from "./financeAutopilot.json";
import financeBankConnections from "./financeBankConnections.json";
import financeBankImport from "./financeBankImport.json";
import financeBanking from "./financeBanking.json";
import financeCardBodies from "./financeCardBodies.json";
import financeChart from "./financeChart.json";
import financeClosing from "./financeClosing.json";
import financeCollections from "./financeCollections.json";
import financeCommercial from "./financeCommercial.json";
import financeConversion from "./financeConversion.json";
import financeDatev from "./financeDatev.json";
import financeDeposits from "./financeDeposits.json";
import financeDocumentReader from "./financeDocumentReader.json";
import financeDocuments from "./financeDocuments.json";
import financeDunning from "./financeDunning.json";
import financeDunningAutomation from "./financeDunningAutomation.json";
import financeEbics from "./financeEbics.json";
import financeEbicsUploads from "./financeEbicsUploads.json";
import financeEinvoices from "./financeEinvoices.json";
import financeFees from "./financeFees.json";
import financeGobd from "./financeGobd.json";
import financeHandover from "./financeHandover.json";
import financeHeating from "./financeHeating.json";
import financeHeatingCo2 from "./financeHeatingCo2.json";
import financeHeatingImports from "./financeHeatingImports.json";
import financeHeatingWays from "./financeHeatingWays.json";
import financeHome from "./financeHome.json";
import financeInvoices from "./financeInvoices.json";
import financeJournal from "./financeJournal.json";
import financeKeys from "./financeKeys.json";
import financeKontierung from "./financeKontierung.json";
import financeMigration from "./financeMigration.json";
import financeOperatingCosts from "./financeOperatingCosts.json";
import financePayables from "./financePayables.json";
import financePayments from "./financePayments.json";
import financePlausibility from "./financePlausibility.json";
import financePortalSettings from "./financePortalSettings.json";
import financeReceipts from "./financeReceipts.json";
import financeReceivables from "./financeReceivables.json";
import financeRecurring from "./financeRecurring.json";
import financeRentChanges from "./financeRentChanges.json";
import financeRentMeasures from "./financeRentMeasures.json";
import financeRental from "./financeRental.json";
import financeReports from "./financeReports.json";
import financeRetention from "./financeRetention.json";
import financeSettingsTabs from "./financeSettingsTabs.json";
import financeSetup from "./financeSetup.json";
import financeSev from "./financeSev.json";
import financeShared from "./financeShared.json";
import financeShell from "./financeShell.json";
import financeTax from "./financeTax.json";
import financeWeg from "./financeWeg.json";
import financeWegAssets from "./financeWegAssets.json";
import financeWegLists from "./financeWegLists.json";
import financeWegOwnerChange from "./financeWegOwnerChange.json";
import financeWegPlans from "./financeWegPlans.json";
import financeWegSettlements from "./financeWegSettlements.json";
import forms from "./forms.json";
import globalSearch from "./globalSearch.json";
import inboxAdminTour from "./inboxAdminTour.json";
import inboxAgentImpl from "./inboxAgentImpl.json";
import inboxOnboardingTour from "./inboxOnboardingTour.json";
import integrationOnboardingTour from "./integrationOnboardingTour.json";
import invoiceFraudChecks from "./invoiceFraudChecks.json";
import learning from "./learning.json";
import learningGate from "./learningGate.json";
import letters from "./letters.json";
import mailbox from "./mailbox.json";
import mailings from "./mailings.json";
import mainWorkspaceLayout from "./mainWorkspaceLayout.json";
import maintenance from "./maintenance.json";
import marketing from "./marketing.json";
import masterData from "./masterData.json";
import masterdataModeSwitch from "./masterdataModeSwitch.json";
import messenger from "./messenger.json";
import meterActions from "./meterActions.json";
import meterBulkReading from "./meterBulkReading.json";
import meterPhotos from "./meterPhotos.json";
import meters from "./meters.json";
import migrationService from "./migrationService.json";
import objectModelDocuments from "./objectModelDocuments.json";
import objectModelInstallations from "./objectModelInstallations.json";
import objectModelKeys from "./objectModelKeys.json";
import objectModelKeysList from "./objectModelKeysList.json";
import objectModelKeysPage from "./objectModelKeysPage.json";
import objectModelRoles from "./objectModelRoles.json";
import objectModelRuns from "./objectModelRuns.json";
import objectModelServiceContracts from "./objectModelServiceContracts.json";
import objectModelSupply from "./objectModelSupply.json";
import onboarding from "./onboarding.json";
import onboardingTour from "./onboardingTour.json";
import orders from "./orders.json";
import pages from "./pages.json";
import partnerProgram from "./partnerProgram.json";
import portal from "./portal.json";
import portalAssembly from "./portalAssembly.json";
import portalFinance from "./portalFinance.json";
import portalFinanceAudit from "./portalFinanceAudit.json";
import postverteilerSetup from "./postverteilerSetup.json";
import productChangeNotices from "./productChangeNotices.json";
import publicMessages from "./public.json";
import replyTimes from "./replyTimes.json";
import roles from "./roles.json";
import sandbox from "./sandbox.json";
import settings from "./settings.json";
import settingsWebhooks from "./settingsWebhooks.json";
import shared from "./shared.json";
import signaturesOnboardingTour from "./signaturesOnboardingTour.json";
import softwareAdmin from "./softwareAdmin.json";
import softwareDialogs from "./softwareDialogs.json";
import softwareGuards from "./softwareGuards.json";
import softwareInvoices from "./softwareInvoices.json";
import softwarePage from "./softwarePage.json";
import softwareProperties from "./softwareProperties.json";
import stammdatenOnboardingTour from "./stammdatenOnboardingTour.json";
import superAdminDashboards from "./superAdminDashboards.json";
import superAdminMarketing from "./superAdminMarketing.json";
import superAdminOffers from "./superAdminOffers.json";
import superAdminOffersDetail from "./superAdminOffersDetail.json";
import superAdminOffersList from "./superAdminOffersList.json";
import superAdminOffersSettings from "./superAdminOffersSettings.json";
import systemAgents from "./systemAgents.json";
import systemPrompts from "./systemPrompts.json";
import takeoverWorkbook from "./takeoverWorkbook.json";
import taskWorkspace from "./taskWorkspace.json";
import teamchatAgentChat from "./teamchatAgentChat.json";
import teamchatAgents from "./teamchatAgents.json";
import teamchatDock from "./teamchatDock.json";
import teamchatOnboardingTour from "./teamchatOnboardingTour.json";
import telefon from "./telefon.json";
import templates from "./templates.json";
import timeTracking from "./timeTracking.json";
import timeTrackingAbsences from "./timeTrackingAbsences.json";
import timeTrackingCalendarOverlay from "./timeTrackingCalendarOverlay.json";
import timeTrackingPersonnelFile from "./timeTrackingPersonnelFile.json";
import timeTrackingSettings from "./timeTrackingSettings.json";
import timeTrackingTeam from "./timeTrackingTeam.json";
import training from "./training.json";
import video from "./video.json";
import voiceAgents from "./voiceAgents.json";
import workflowActivity from "./workflowActivity.json";
import workflowBoard from "./workflowBoard.json";
import workflowCard from "./workflowCard.json";
import workflowEditor from "./workflowEditor.json";
import workflowSettings from "./workflowSettings.json";
import workflowShared from "./workflowShared.json";

export default {
  accountSetup,
  accountSetupEmail,
  accountSetupEpost,
  accountSetupKi,
  accountSetupList,
  accountSetupPhone,
  accountSetupWhatsapp,
  agentChats,
  agentChatsImpl,
  agentExecutions,
  agentOnboardingTour,
  agentOptimization,
  agentOptimizationAgent,
  agentOptimizationChat,
  agentOptimizationList,
  agentOptimizationMarks,
  agentOptimizationProblem,
  agentRunChat,
  apiDocumentation,
  assemblies,
  automations,
  boardAutomations,
  buildingScope,
  bulkActions,
  calendar,
  clips,
  common,
  communityComposer,
  communityFrame,
  communityLive,
  communityPosts,
  communityTemplates,
  connectAi,
  dataSources,
  demoPost,
  docs,
  documents,
  documentsAdminTour,
  documentsOnboardingTour,
  drive,
  einvoiceRuleHelp,
  einvoiceRules,
  emailAccountDisconnected,
  emailImportOnboardingTour,
  errors,
  exports,
  featurePages,
  financeAiSelfPosting,
  financeAllocation,
  financeApprovals,
  financeAudit,
  financeAuditAccess,
  financeAuditLink,
  financeAutopilot,
  financeBankConnections,
  financeBankImport,
  financeBanking,
  financeCardBodies,
  financeChart,
  financeClosing,
  financeCollections,
  financeCommercial,
  financeConversion,
  financeDatev,
  financeDeposits,
  financeDocumentReader,
  financeDocuments,
  financeDunning,
  financeDunningAutomation,
  financeEbics,
  financeEbicsUploads,
  financeEinvoices,
  financeFees,
  financeGobd,
  financeHandover,
  financeHeating,
  financeHeatingCo2,
  financeHeatingImports,
  financeHeatingWays,
  financeHome,
  financeInvoices,
  financeJournal,
  financeKeys,
  financeKontierung,
  financeMigration,
  financeOperatingCosts,
  financePayables,
  financePayments,
  financePlausibility,
  financePortalSettings,
  financeReceipts,
  financeReceivables,
  financeRecurring,
  financeRentChanges,
  financeRentMeasures,
  financeRental,
  financeReports,
  financeRetention,
  financeSettingsTabs,
  financeSetup,
  financeSev,
  financeShared,
  financeShell,
  financeTax,
  financeWeg,
  financeWegAssets,
  financeWegLists,
  financeWegOwnerChange,
  financeWegPlans,
  financeWegSettlements,
  forms,
  globalSearch,
  inboxAdminTour,
  inboxAgentImpl,
  inboxOnboardingTour,
  integrationOnboardingTour,
  invoiceFraudChecks,
  learning,
  learningGate,
  letters,
  mailbox,
  mailings,
  mainWorkspaceLayout,
  maintenance,
  marketing,
  masterData,
  masterdataModeSwitch,
  messenger,
  meterActions,
  meterBulkReading,
  meterPhotos,
  meters,
  migrationService,
  objectModelDocuments,
  objectModelInstallations,
  objectModelKeys,
  objectModelKeysList,
  objectModelKeysPage,
  objectModelRoles,
  objectModelRuns,
  objectModelServiceContracts,
  objectModelSupply,
  onboarding,
  onboardingTour,
  orders,
  pages,
  partnerProgram,
  portal,
  portalAssembly,
  portalFinance,
  portalFinanceAudit,
  postverteilerSetup,
  productChangeNotices,
  public: publicMessages,
  replyTimes,
  roles,
  sandbox,
  settings,
  settingsWebhooks,
  shared,
  signaturesOnboardingTour,
  softwareAdmin,
  softwareDialogs,
  softwareGuards,
  softwareInvoices,
  softwarePage,
  softwareProperties,
  stammdatenOnboardingTour,
  superAdminDashboards,
  superAdminMarketing,
  superAdminOffers,
  superAdminOffersDetail,
  superAdminOffersList,
  superAdminOffersSettings,
  systemAgents,
  systemPrompts,
  takeoverWorkbook,
  taskWorkspace,
  teamchatAgentChat,
  teamchatAgents,
  teamchatDock,
  teamchatOnboardingTour,
  telefon,
  templates,
  timeTracking,
  timeTrackingAbsences,
  timeTrackingCalendarOverlay,
  timeTrackingPersonnelFile,
  timeTrackingSettings,
  timeTrackingTeam,
  training,
  video,
  voiceAgents,
  workflowActivity,
  workflowBoard,
  workflowCard,
  workflowEditor,
  workflowSettings,
  workflowShared,
};
